import Vue from 'vue';
import fb from '@/firebaseConfig';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'AppHome',
      component: () => import(/* webpackChunkName: "app-home" */ './views/AppHome-View.vue'),
      meta: {
        requiresAuth: true,
        hasBottomBar: true,
      },
    },
    {
      path: '/auth',
      name: 'Auth',
      component: () => import(/* webpackChunkName: "auth" */ './views/Auth-View.vue'),
    },
    {
      path: '/auth/action', // Action URL for Auth templates
      name: 'AuthAction',
      component: () => import(/* webpackChunkName: "auth-action" */ './views/Auth-View.vue'),
    },
    {
      // Auth pages for updating while signed in
      // actions: upgrade-anonymous, reset-password, reauthenticate
      path: '/auth/update/:action',
      name: 'AuthUpdate',
      component: () => import(/* webpackChunkName: "auth-update" */ './views/Auth-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/explore',
      name: 'Explore',
      component: () => import(/* webpackChunkName: "app-explore" */ './views/Explore-View.vue'),
      meta: {
        requiresAuth: true,
        hasBottomBar: true,
      },
    },
    {
      path: '/category/:category',
      name: 'Category',
      component: () => import(/* webpackChunkName: "app-category" */ './views/Category-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
        hasBottomBar: true,
      },
    },
    {
      path: '/card/:id',
      name: 'Card',
      component: () => import(/* webpackChunkName: "app-card" */ './views/Content-View.vue'),
      meta: {
        requiresAuth: true,
        isContentView: true,
        hasTopBar: true,
      },
    },
    {
      path: '/card/:id/audio',
      name: 'AudioCard',
      component: () => import(/* webpackChunkName: "app-audio-card" */ './views/Content-View.vue'),
      meta: {
        requiresAuth: true,
        isContentView: true,
        isAudioView: true,
        hasTopBar: true,
      },
    },
    {
      path: '/stacks',
      name: 'Stacks',
      component: () => import(/* webpackChunkName: "app-stacks" */ './views/Stacks-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
        hasBottomBar: true,
      },
    },
    {
      path: '/stack/:id',
      name: 'Stack',
      component: () => import(/* webpackChunkName: "app-stack" */ './views/Content-View.vue'),
      meta: {
        requiresAuth: true,
        isContentView: true,
        hasTopBar: true,
      },
    },
    {
      path: '/stack/:id/audio',
      name: 'AudioStack',
      component: () => import(/* webpackChunkName: "app-audio-stack" */ './views/Content-View.vue'),
      meta: {
        requiresAuth: true,
        isContentView: true,
        isAudioView: true,
        isPremium: true,
        hasTopBar: true,
      },
    },
    {
      path: '/menu',
      name: 'Menu',
      component: () => import(/* webpackChunkName: "app-menu" */ './views/Menu-View.vue'),
      meta: {
        requiresAuth: true,
        hasBottomBar: true,
      },
    },

    {
      path: '/help',
      name: 'HelpHome',
      component: () => import(/* webpackChunkName: "app-helphome" */ './views/HelpHome-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/help/:id',
      name: 'Help',
      // component: () => import('./views/HelpPage-View.vue'),
      component: () => import(/* webpackChunkName: "app-help" */ './views/Content-View.vue'),
      meta: {
        requiresAuth: true,
        isContentView: true,
        hasTopBar: true,
      },
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import(/* webpackChunkName: "app-contact" */ './views/Contact-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/account',
      name: 'Account',
      component: () => import(/* webpackChunkName: "app-account" */ './views/Account-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/visionaries',
      name: 'Visionaries',
      component: () =>
        import(/* webpackChunkName: "app-visionaries" */ './views/Visionaries-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "app-about" */ './views/About-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },

    {
      path: '/about-audio',
      name: 'AboutAudio',
      component: () =>
        import(/* webpackChunkName: "app-aboutaudio" */ './views/AboutAudio-View.vue'),
      meta: {
        requiresAuth: true,
        hasTopBar: true,
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Policy-View.vue'),
      meta: {
        hasTopBar: true,
      },
    },
    {
      path: '/terms',
      name: 'Terms',
      component: () => import(/* webpackChunkName: "terms" */ './views/Policy-View.vue'),
      meta: {
        hasTopBar: true,
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // console.log('Router', { to, from });
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const { currentUser } = fb.auth();

  Vue.prototype.$fromRoute = from;

  if (requiresAuth && !currentUser) {
    next({ name: 'Auth', query: { redirect: to.path } });
  } else {
    next();
  }
});

export default router;
